import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_WAITING,
  AUTH_STATUS_WARNING,
} from "constants/FormatDataContanst";
import { convertToDD_MM_YYY } from "helpers/utils";

export const getReportStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      text: "Tạo mới",
      badgeColor: "badge-soft-secondary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: "Đang xử lý",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: "Hoàn tất import",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_AR]: {
      text: "Hợp lệ",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_REJECT]: {
      text: "Lỗi validate",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_WARNING]: {
      text: "Cảnh báo",
      badgeColor: "badge-soft-warning",
    },
  };

  const APPROVE_STATUS = {
    [APPROVE_STATUS_M]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-info",
    },
    [APPROVE_STATUS_P]: {
      //""Gửi chờ duyệt",",
      text: "Gửi chờ duyệt",
      badgeColor: "badge-soft-warning",
    },
    [APPROVE_STATUS_A]: {
      //"Đã duyệt",
      text: "Đã duyệt",
      badgeColor: "badge-soft-success",
    },
    [APPROVE_STATUS_R]: {
      //"Từ chối duyệt",
      text: "Từ chối duyệt",
      badgeColor: "badge-soft-danger",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
    APPROVE_STATUS: APPROVE_STATUS,
  };
};

export const getReportPortalStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      text: "Tạo mới",
      badgeColor: "badge-soft-secondary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: "Đang xử lý",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: "Hoàn tất",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_AR]: {
      text: "Hợp lệ",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_REJECT]: {
      text: "Lỗi validate",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_WARNING]: {
      text: "Cảnh báo",
      badgeColor: "badge-soft-warning",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};

export const getTimeContent = cellContent => {
  if (cellContent.month) {
    return `Tháng ${cellContent.month}_${cellContent.year}`;
  }
  if (cellContent.quarter) {
    return `Quý ${cellContent.quarter}_${cellContent.year}`;
  }
  if (cellContent.date && cellContent.date.length === 2) {
    return `${convertToDD_MM_YYY(cellContent.date[0])} ~ ${convertToDD_MM_YYY(
      cellContent.date[1]
    )}`;
  }
  if (cellContent.date_from && cellContent.date_to) {
    return `${convertToDD_MM_YYY(
      cellContent.date_from,
      "_"
    )}_${convertToDD_MM_YYY(cellContent.date_to, "_")}`;
  }
  return "";
};

export const TCTBAO_LABEL = {
  0: "0 - Mới",
  1: "1 - Hủy",
  2: "2 - Điều chỉnh",
  3: "3 - Thay thế",
  4: "4 - Giải trình",
  5: "5 - Sai sót do tổng hợp",
};

export const getInvoiceStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: "Đang ký",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_WAITING]: {
      text: "Chờ phát hành",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: "Đã phát hành",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_REJECT]: {
      text: "Lỗi",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_AR]: {
      text: "Validate hoàn tất",
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_WARNING]: {
      text: "Cảnh báo",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_CANCEL]: {
      text: "Hủy",
      badgeColor: "badge-soft-danger",
    },
  };

  const APPROVE_STATUS = {
    [APPROVE_STATUS_M]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-info",
    },
    [APPROVE_STATUS_P]: {
      //""Gửi chờ duyệt",",
      text: "Gửi chờ duyệt",
      badgeColor: "badge-soft-warning",
    },
    [APPROVE_STATUS_A]: {
      //"Đã duyệt",
      text: "Đã duyệt",
      badgeColor: "badge-soft-success",
    },
    [APPROVE_STATUS_R]: {
      //"Từ chối duyệt",
      text: "Từ chối duyệt",
      badgeColor: "badge-soft-danger",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
    APPROVE_STATUS: APPROVE_STATUS,
  };
};
